var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdpTabBase',{staticClass:"pdp-vehicle-types-tab",class:_vm.classes,attrs:{"headline":_vm.$t('pdp-vehicle-types-tab.headline'),"data-preload":[_vm.$options.name],"is-expanded":_vm.activeTab}},[_c('PdpCarTypesTable',{attrs:{"product-id":_vm.productId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }